module.exports = __webpack_public_path__ + "img/flag-icon-sp.f07c6fc5.png";